import { render } from "./NoReview.vue?vue&type=template&id=7aa48c90&scoped=true&ts=true"
import script from "./NoReview.vue?vue&type=script&lang=ts"
export * from "./NoReview.vue?vue&type=script&lang=ts"

import "./NoReview.vue?vue&type=style&index=0&id=7aa48c90&lang=scss&scoped=true"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aa48c90"]])

export default __exports__